import { Pipe, PipeTransform } from '@angular/core';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
    name: 'firestoreDate',
    standalone: false
})
export class FirestoreDatePipe implements PipeTransform {
  transform(timestamp: any, format?: string, asUtc = false): string | any {
    if (!timestamp) {
      return null;
    }

    const milliseconds = this.toMilliseconds(timestamp);

    if (milliseconds === null) {
      return null;
    }

    return asUtc
      ? dayjs.utc(milliseconds).format(format)
      : dayjs(milliseconds).format(format);
  }

  private toMilliseconds(timestamp: any): number | null {
    if (timestamp instanceof Date) {
      const milliseconds = timestamp.getTime();
      return Number.isNaN(milliseconds) ? null : milliseconds;
    }

    if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      const milliseconds = dayjs(timestamp).valueOf();
      return Number.isNaN(milliseconds) ? null : milliseconds;
    }

    if (typeof timestamp?.toMillis === 'function') {
      const milliseconds = timestamp.toMillis();
      return Number.isFinite(milliseconds) ? milliseconds : null;
    }

    const seconds = timestamp?.seconds ?? timestamp?._seconds;

    if (typeof seconds === 'number') {
      const nanoseconds = timestamp?.nanoseconds ?? timestamp?._nanoseconds ?? 0;
      return (seconds * 1000) + (nanoseconds / 1_000_000);
    }

    return null;
  }
}
